// components/YenimahalleSidebar.jsx

import React from "react";
import { Link, useLocation } from "react-router-dom";

const serviceAreas = [
  {
    label: "Ata Mahallesi Halı Yıkama",
    path: "/yenimahalle/ata-hali-yikama",
    description:
      "Ata Mahallesi’nde halılarınız antibakteriyel ürünlerle hijyenik şekilde temizlenir. Kapıdan alım ve teslimat ücretsizdir."
  },
  {
    label: "Çakırlar Halı Yıkama",
    path: "/yenimahalle/cakirlar-hali-yikama",
    description:
      "Çakırlar bölgesine özel servisimiz ile halılarınızı modern makinelerde, lif yapısına zarar vermeden yıkıyoruz."
  },
  {
    label: "Demet Halı Yıkama",
    path: "/yenimahalle/demet-hali-yikama",
    description:
      "Demet Mahallesi’nde organik temizlik ürünleri ile sağlıklı halı yıkama hizmeti sunuyoruz. Ücretsiz servis mevcuttur."
  },
  {
    label: "İvedik Halı Yıkama",
    path: "/yenimahalle/ivedik-hali-yikama",
    description:
      "İvedik’te halılarınız profesyonel sistemlerle yıkanır, steril şekilde paketlenerek teslim edilir."
  },
  {
    label: "Batıkent Halı Yıkama",
    path: "/yenimahalle/batikent-hali-yikama",
    description:
      "Batıkent bölgesine özel hızlı ve hijyenik halı yıkama hizmeti sunuyoruz. Halılarınız itina ile temizlenir."
  },
  {
    label: "Karşıyaka Halı Yıkama",
    path: "/yenimahalle/karsiyaka-hali-yikama",
    description:
      "Karşıyaka Mahallesi’nde uygun fiyatlı, garantili halı yıkama çözümleri sunmaktayız."
  },
  {
    label: "Ostim Halı Yıkama",
    path: "/yenimahalle/ostim-hali-yikama",
    description:
      "Ostim semtine yönelik halı yıkama servisimizde, ticari ve bireysel müşterilere özel çözümler sunuyoruz."
  },
  {
    label: "Macun Mah. Halı Yıkama",
    path: "/yenimahalle/macun-hali-yikama",
    description:
      "Macun Mahallesi’nde profesyonel ekiplerimiz halılarınızı evden alır, en iyi şekilde temizleyip teslim eder."
  },
  {
    label: "Varlık Mah. Halı Yıkama",
    path: "/yenimahalle/varlik-hali-yikama",
    description:
      "Varlık Mahallesi için sunduğumuz halı yıkama hizmeti; çevre dostu ürünlerle, sağlığınıza zarar vermeden gerçekleştirilir."
  },
  {
    label: "Serhat Mah.Halı Yıkama",
    path: "/yenimahalle/serhat-hali-yikama",
    description:
      "Serhat Mahallesi’nde halı yıkama taleplerinizi aynı gün karşılıyor, üstün temizlik kalitesi sunuyoruz."
  },
];


const YenimahalleSidebar = () => {
  const location = useLocation();
 return (
    <div className="mt-2 text-[#003132]">
        <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">YENİMAHALLE SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {serviceAreas.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default YenimahalleSidebar;


